import Layout2 from '@/layout/Layout2'
let ja = require('../../common/lang/ja')
let zh = require('../../common/lang/zh-CN')

export default [{
    path: '/orderStatistic',
    component: Layout2,
    meta: { zhtitle: zh.m.router.common.ORDER_SAT, jatitle: ja.m.router.common.ORDER_SAT },
    children: [{
        path: '',
        name: 'orderStatistic',
        component: () => import( /* webpackChunkName: "jp.orderStatistic" */ '@/merchanAdmin/orderStatistic/list'),
        meta: {
            zhtitle: zh.m.router.common.ORDER_SAT,
            jatitle: ja.m.router.common.ORDER_SAT,
            pername: "order_statistics"
        },
    }]
}]
